import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { addCollaborator, DeleteKeys } from "../../../../../../actions/appsMoreAction";
import { emailValidation, TOAST_DISMISS, TOAST_ERROR, TOAST_LOADING, TOAST_SUCCESS,baseUrl } from "../../../../../../utils";
import { shallowEqual, useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { togglePlanSection_D } from "../../../../../../actions/showDisplayModalAction";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

export default function Collaborator(props) {
  const dispatch = useDispatch();
  const [emailError, setEmailError] = useState(false);
  const [value_1, setValue_1] = useState(false)
  const [email, setEmail] = useState({ email: "" });
  const [value, setValue] = useState();
  const [spinner, setspinner] = useState(false);
  const { userData } = useSelector((state) => state.authenticated, shallowEqual);

  var data = `${email.email}`;

  const onSubmit = (e) => {
    setEmailError(!emailValidation(data))
    setValue_1(value ? false : true)
    if (!emailValidation(data) || !value) return
    setspinner(true);
    TOAST_LOADING()
    const data_1 = { emailId: email.email, collaboratorRole: value };
    addCollaborator(data_1)
      .then((res) => {
        if (res.status == 200) {
          TOAST_DISMISS()
          TOAST_SUCCESS(res.data?.responseData)
          setspinner(false);
          DeleteKeys()
          props.getNewData();
          props.onHide()
        } else {
          TOAST_DISMISS()
          TOAST_ERROR(res.message);
          setspinner(false);
          props.onHide();
        }
      }).catch((res) => {
        TOAST_DISMISS()
        TOAST_ERROR(res.response.data.responseMessage);
        setspinner(false);
        props.onHide();
      })
  };
  function keyDown(e) {
    var e = window.event || e;
    var key = e.keyCode;
    if (key == 32) {
      e.preventDefault();
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {props.collaboratorList.length != userData?.UserRule.collaborator && userData?.UserRule.collaboratorStatus != 0 ? <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Add Collaborator</h4>
          <button
            type="button"
            className="btn-close"
            onClick={() => props.onHide()}
            data-bs-dismiss="modal"
            aria-label="Close"
            aria-hidden="true"
          >
          </button>
        </div>
        <div className="modal-body">
          <div className="addCollabrtr">
            <div className="portlet-body" id="addCollaboratorBlock">
              <div
                className="init maintainPopUp noLoader"
                id="collaboratorCreatePopUp"
              >
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>
                        Enter Email <span>*</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <FontAwesomeIcon type={'solid'} icon={'user-plus'} iconClass="fa-duotone fs-6"/>
                          </span>
                        </div>
                        <input
                          onKeyDown={(e) => keyDown(e)}
                          className="form-control brdrLftNoRafius"
                          onChange={(e) => {
                            setEmailError(false)
                            e.preventDefault();
                            setEmail({ email: e.target.value });
                          }}
                          type="text"
                        />
                      </div>
                    </div>
                    <span id="wallsurlerror" className="errorMessage required">
                      {emailError ? "Kindly enter valid E-mail ID" : ""}
                    </span>
                    <span
                      className="errorMessage required"
                    ></span>
                  </div>
                </div>
                <div className="row allPrmissins mb-5">
                  <div className="col-md-4">
                    <div className="radio-inline">
                      <label className="radio radio-outline radio-primary d-flex align-items-center">
                        <input
                          type="radio"
                          name="data[Collaborator][collaboratorRole]"
                          id="CollaboratorCollaboratorRole1"
                          className="CollaboratorCollaboratorRole"
                          value="1"
                          onChange={() => {
                            setValue("1");
                            setValue_1(false)
                          }}
                        />
                        <span></span>Admin
                      </label>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="radio-inline">
                      <label className="radio radio-outline radio-primary d-flex align-items-center">
                        <input
                          type="radio"
                          name="data[Collaborator][collaboratorRole]"
                          id="CollaboratorCollaboratorRole2"
                          className="CollaboratorCollaboratorRole"
                          value="2"
                          onChange={() => {
                            setValue("2");
                            setValue_1(false)
                          }}
                        />
                        <span></span>Editor
                      </label>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="radio-inline">
                      <label className="radio radio-outline radio-primary d-flex align-items-center">
                        <input type="radio" name="data[Collaborator][collaboratorRole]" id="CollaboratorCollaboratorRole3" className="CollaboratorCollaboratorRole" value="3" onChange={() => { setValue("3"); setValue_1(false)}}
                        />
                        <span></span>Moderator
                      </label>
                    </div>
                  </div>
                  <span className="errorMessage required">
                    {value_1 ? "Please select at least one role" : ""}
                  </span>
                </div>
                <div className="row border-top">
                  <div className="col-12 text-right pt-4">
                    <Button variant="primary" className={`addCol ${spinner ? `spinner spinner-white spinner-right disabled` : null}`} onClick={(e) => onSubmit(e)}>
                      Add Collaborator
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        : <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <button type="button" className="btn-close" onClick={() => props.onHide()} aria-hidden="true"></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12">
                <div className="upgredeMain text-center">
                  <div className="Erroricon" style={{ display: 'none' }}><span className=""></span></div>
                  <div className="Errorimage pb-3" ><img style={{ width: '720px' }} src={baseUrl(`error/collaboration-error.png`)} className="img-fluid" width={500} height={300} alt="Upgrade Plan" /></div>
                  <div className="permissionMsg my-4 px-4">
                    <h4 className="ErrorMsg">Collaboration Feature</h4>
                    <p className="msgSec">Provide access to more members of your team who can edit or customize your widget and develop stunning widget with teamwork.</p>
                  </div>
                  <div className="buttonUpgred mb-3">
                    <Button variant="primary" id="addonFeaturesScroll" onClick={(e) => dispatch(togglePlanSection_D(true))} className="commanBtn px-5">
                      Upgrade Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </Modal>
  );
}
